var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmergencyHome = function SvgEmergencyHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "emergency_home_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#emergency_home_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 22.025q-.4 0-.762-.15a2.3 2.3 0 0 1-.663-.425L2.55 13.425q-.275-.3-.425-.662T1.975 12t.15-.775.425-.65l8.025-8.025q.3-.3.663-.437.361-.138.762-.138.4 0 .775.138.375.137.65.437l8.025 8.025q.3.275.438.65a2.23 2.23 0 0 1 0 1.538 1.9 1.9 0 0 1-.438.662l-8.025 8.025q-.275.275-.65.425t-.775.15m0-2L20.025 12 12 3.975 3.975 12zM12 13q.424 0 .713-.287A.97.97 0 0 0 13 12V8a.97.97 0 0 0-.287-.712A.97.97 0 0 0 12 7a.97.97 0 0 0-.713.288A.97.97 0 0 0 11 8v4q0 .424.287.713.288.287.713.287m0 3q.424 0 .713-.287A.97.97 0 0 0 13 15a.97.97 0 0 0-.287-.712A.97.97 0 0 0 12 14a.97.97 0 0 0-.713.288A.97.97 0 0 0 11 15q0 .424.287.713.288.287.713.287"
  }))));
};
export default SvgEmergencyHome;